module.exports = __webpack_public_path__ + "images/onde.png?5aa4038ef6151bf44b7f9e409fc33945";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ticket/onde.png
// module id = d747df14b07e86bea17a
// module chunks = 36